<template>
  <div class="home-section">
    <div class="home-section-inner">
      <div class="head flex flex-center flex-column flex-middle">
        <div class="head-name">协会专区</div>
        <div class="head-tips">Association Zone</div>
        <!-- <div @click="toList" class="head-more pointer">更多></div> -->
      </div>
      <div class="con" v-loading="loading">
        <div v-for="(item, index) in lists" :key="index" class="con-card">
          <h3 class="con-card-title">{{ item.leagueName }}</h3>
          <Member
            :leagueName="item.leagueName"
            :members="item.leagueMembers"
            :roleMap="roleMap"
            @nameClick="allianceDetail(item)"
          />
          <div class="dynamic-con flex">
            <div class="flex-1">
              <template v-for="(dynamic, dIndex) in item.leagueActivities">
                <div
                  :key="`d${dIndex}`"
                  class="dynamic-con-list pointer ellipsis"
                  @click="allianceActDetail(dynamic, item)"
                  v-if="dIndex < 6"
                >
                  <span>{{ dynamic.activityTitle }}</span>
                </div>
              </template>
            </div>
            <el-carousel trigger="click" height="150px">
              <template v-for="(pic, index) in item.leagueCarousels">
                <el-carousel-item :key="index" v-if="index < 6">
                  <img :src="pic.carouselUrl" class="carousel-img" />
                </el-carousel-item>
              </template>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { allianceHomeList } from "@/api/allianceZone";
import { ALLIANCE_ROLE } from "@/constant/dict";
import Member from "./Members.vue";
export default {
  components: {
    Member,
  },
  data() {
    return {
      lists: [],
      roleMap: {},
      loading: false,
    };
  },
  async created() {
    this.getDict();
    this.getList();
  },
  methods: {
    async getDict() {
      const res = await this.$store.dispatch("getDictData", ALLIANCE_ROLE);
      const dMap = {};
      res.forEach((item) => {
        dMap[item.dictValue] = item.dictLabel;
      });
      this.roleMap = dMap;
    },
    async getList() {
      this.loading = true;
      const data = await this.$axios.get(allianceHomeList).finally(() => {
        this.loading = false;
      });
      this.lists = data;
    },
    toList() {
      this.$jump.push({ name: "allianceList" });
    },
    allianceDetail(data) {
      this.$jump.push({
        name: "allianceDetail",
        query: { id: data.leagueId },
      });
    },
    allianceActDetail({ leagueActivityId }, { leagueId }) {
      this.$jump.push({
        name: "allianceActDetail",
        query: { id: leagueActivityId, detailId: leagueId },
      });
    },
    toLabDetail({ laborarotyId }) {
      this.$jump.push({
        name: "labDetail",
        query: { id: laborarotyId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";

.con {
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 8px));
  gap: 15px;
  &-card {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e9e9e9;
    border-top: none;
    &-title {
      text-align: center;
      padding: 10px 0;
      color: #fff;
      background: url($oss-url + "home/title-bg/title-bg-2.png") no-repeat
        center center / cover;
    }
  }
}

.dynamic-con {
  padding: 0 15px 15px 15px;
  ::v-deep .el-carousel {
    width: 200px;
    .carousel-img {
      width: 200px;
      height: 150px;
      border-radius: 4px;
      object-fit: cover;
    }
  }
  ::v-deep .el-carousel__button {
    width: 3px;
  }
  &-list {
    padding-left: 10px;
    max-width: 350px;
    margin-bottom: 4px;
    &::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 2px;
      background: #f61b29;
      margin-right: 10px;
      margin-bottom: 3px;
    }
  }
}
</style>
